// extracted by mini-css-extract-plugin
export default {"block":"Ki","info":"Li","error":"Mi","noSpace":"Ni","optional":"Oi"};